import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div>
            <h1>PrivacyPolicy</h1>
        </div>
    )
}

export default PrivacyPolicy
